import {Alert, Button, Popover, Row, Col} from "antd";
import {useParams} from "react-router-dom";
import {useChoiceAnalysisCheckDeclinedMutation, useGetNegotiationDetailQuery} from "../../redux/api/negotiationsApiSlice";
import {skipToken} from "@reduxjs/toolkit/query";
import {CheckCircleOutlined, CloseCircleOutlined, DownOutlined} from "@ant-design/icons";
import {assistantBg, assistantBorder, assistantColor, CustomRobotIcon} from "./sidebars/AIAssistant/utils/CustomRobotIcon";
import {useState} from "react";
import {JOB_STATUS} from "../../types/reconciliation";
import ReactMarkdown from "react-markdown";

export default function CheckDeclined({isCurrentStep, startPolling, callBackUpdateNegotiation}: { isCurrentStep: boolean, startPolling: () => void, callBackUpdateNegotiation: ()=> void }) {

    const {id} = useParams()

    const {data: negotiationData} = useGetNegotiationDetailQuery(id ?? skipToken)
    const [checkDeclineChoice, {isLoading: checkDeclineLoading}] = useChoiceAnalysisCheckDeclinedMutation()

    const [popoverDeclineOpen, setPopoverDeclineOpen] = useState<boolean>(false)
    const [popoverContinueOpen, setPopoverContinueOpen] = useState<boolean>(false)

    const acceptDecline = () => {
        setPopoverDeclineOpen(false)
        if (id) {
            checkDeclineChoice({negID: id, uw_accepted_decline_suggestion: true}).unwrap()
                .then(()=> callBackUpdateNegotiation())
        }
    }

    const rejectDecline = () => {
        setPopoverContinueOpen(false)
        if (id) {
            checkDeclineChoice({negID: id, uw_accepted_decline_suggestion: false}).unwrap()
                .then(res => startPolling())
        }
    }

    const declinePopoverContent = () => {
        return <div>
            Confermi di voler declinare questa submission?
            <Row justify={"end"} style={{marginTop: "1rem"}}>
                <Button size={"small"} type={"primary"} danger onClick={() => acceptDecline()}>
                    Declina
                </Button>
            </Row>
        </div>
    }

    const continueAnalysisPopoverContent = () => {
        return <div>
            Continuando con l'operazione i dati attualmente presenti potranno essere sovrascritti. <br/>
            Si desidera continuare?
            <Row justify={"end"} style={{marginTop: "1rem"}}>
                <Button size={"small"} type={"primary"} onClick={() => rejectDecline()}>
                    Continua analisi
                </Button>
            </Row>
        </div>
    }

    return <div style={{ marginTop: "1rem" }}>
        {
            negotiationData?.negotiation_analysis?.decline_suggestion_message
            && <Alert
                style={{
                    color: assistantColor,
                    backgroundColor: assistantBg,
                    borderColor: assistantBorder,
                    marginBottom: "1rem",
                }}
                type="info"
                message={
                    <strong style={{ color: assistantColor }}>
                        ERIK:
                    </strong>
                }
                description={
                    <ReactMarkdown>
                        { negotiationData.negotiation_analysis.decline_suggestion_message }
                    </ReactMarkdown>
                }
                showIcon={true}
                icon={<CustomRobotIcon />}
            />
        }
        {
            negotiationData?.negotiation_analysis?.is_decline_suggested
            ? <div
                style={{
                    alignItems: "center",
                    color: "red",
                    display: "inline-flex",
                    marginBottom: "1rem",
                    justifyContent: "center",
                }}
            >
                <CloseCircleOutlined
                    style={{
                        display: "inline-block",
                        fontSize: "1.25rem",
                        marginRight: "0.5rem",
                        verticalAlign: "middle",
                    }}
                />
                <div>
                    ERIK consiglia di
                    {" "}
                    <strong>
                        DECLINARE
                    </strong>
                    {" "}
                    la quotazione
                </div>
            </div>
            : <div
                style={{
                    alignItems: "center",
                    color: "green",
                    display: "inline-flex",
                    justifyContent: "center",
                }}
            >
                <CheckCircleOutlined
                    style={{
                        display: "inline-block",
                        fontSize: "1.25rem",
                        marginRight: "0.5rem",
                        verticalAlign: "middle",
                    }}
                />
                <div>
                    ERIK consiglia di
                    {" "}
                    <strong>
                        PROCEDERE
                    </strong>
                    {" "}
                    con la quotazione
                </div>
            </div>
        }
        {
            negotiationData?.negotiation_analysis?.analysis_status !== JOB_STATUS.ERROR
            && isCurrentStep
            && !negotiationData?.negotiation_analysis?.uw_accepted_decline_suggestion
            && <Row
                style={{ marginBottom: "1rem" }}
                gutter={[8, 8]}
                justify={"center"}
            >
                <Col
                    sm={24}
                    md={8}
                    lg={10}
                    xl={8}
                >
                    <Popover
                        placement="top"
                        title={"Attenzione"}
                        content={declinePopoverContent()}
                        open={popoverDeclineOpen}
                        onOpenChange={open => setPopoverDeclineOpen(open)}
                        trigger={"click"}
                    >
                        <Button
                            block={true}
                            type={"primary"}
                            loading={checkDeclineLoading}
                            danger={true}
                        >
                            Declina quotazione
                        </Button>
                    </Popover>
                </Col>
                <Col
                    sm={24}
                    md={8}
                    lg={10}
                    xl={8}
                >
                    <Popover
                        placement={"top"}
                        title={"Attenzione"}
                        content={continueAnalysisPopoverContent()}
                        open={popoverContinueOpen}
                        trigger={"click"}
                        onOpenChange={open => setPopoverContinueOpen(open)}
                    >
                        <Button
                            block={true}
                            type={"primary"}
                            disabled={checkDeclineLoading}
                        >
                            Continua analisi
                        </Button>
                    </Popover>
                </Col>
            </Row>
        }
    </div>
}
